document.addEventListener("DOMContentLoaded", () => {

document.querySelectorAll(".price-slider").forEach(slider=>{

const minSlider=slider.querySelector(".price-slider__range--min");
const maxSlider=slider.querySelector(".price-slider__range--max");
const fill=slider.querySelector(".price-slider__fill");

const wrapper=slider.parentElement;

const inputs=wrapper.querySelectorAll(".field__input");

const minInput=inputs[0];
const maxInput=inputs[1];

const max=parseFloat(slider.dataset.max);

function updateFill(){

let min=parseFloat(minSlider.value);
let maxVal=parseFloat(maxSlider.value);

const left=(min/max)*100;
const right=(maxVal/max)*100;

fill.style.left=left+"%";
fill.style.width=(right-left)+"%";

}

function syncFromSlider(){

let min=parseFloat(minSlider.value);
let maxVal=parseFloat(maxSlider.value);

if(min>maxVal){

min=maxVal;

minSlider.value=min;

}

minInput.value=min;

maxInput.value=maxVal;

updateFill();

}

function syncFromInputs(){

let min=parseFloat(minInput.value)||0;

let maxVal=parseFloat(maxInput.value)||max;

if(min>maxVal){

min=maxVal;

}

minSlider.value=min;

maxSlider.value=maxVal;

updateFill();

}

minSlider.addEventListener("input",syncFromSlider);

maxSlider.addEventListener("input",syncFromSlider);

minInput.addEventListener("input",syncFromInputs);

maxInput.addEventListener("input",syncFromInputs);

updateFill();

});

});